/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DisputePenalty
 */
export interface DisputePenalty {
    /**
     * 
     * @type {string}
     * @memberof DisputePenalty
     */
    teamId?: string;
    /**
     * 
     * @type {string}
     * @memberof DisputePenalty
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof DisputePenalty
     */
    description?: string;
    /**
     * 
     * @type {number}
     * @memberof DisputePenalty
     */
    appliedAt?: number;
}

/**
 * Check if a given object implements the DisputePenalty interface.
 */
export function instanceOfDisputePenalty(value: object): value is DisputePenalty {
    return true;
}

export function DisputePenaltyFromJSON(json: any): DisputePenalty {
    return DisputePenaltyFromJSONTyped(json, false);
}

export function DisputePenaltyFromJSONTyped(json: any, ignoreDiscriminator: boolean): DisputePenalty {
    if (json == null) {
        return json;
    }
    return {
        
        'teamId': json['teamId'] == null ? undefined : json['teamId'],
        'type': json['type'] == null ? undefined : json['type'],
        'description': json['description'] == null ? undefined : json['description'],
        'appliedAt': json['appliedAt'] == null ? undefined : json['appliedAt'],
    };
}

export function DisputePenaltyToJSON(json: any): DisputePenalty {
    return DisputePenaltyToJSONTyped(json, false);
}

export function DisputePenaltyToJSONTyped(value?: DisputePenalty | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'teamId': value['teamId'],
        'type': value['type'],
        'description': value['description'],
        'appliedAt': value['appliedAt'],
    };
}

